import { BackupSubscriptionTypes } from './backup-enums';

export class ReindexSubscriptionRequest {
  subscriptionType: BackupSubscriptionTypes;
  includeExcludedItems: boolean;
  includeDeletedItems: boolean;
  isHardReindex: boolean;
  ingestDirectly: boolean;
}
